import { QueryClientContext } from "../../context/QueryClientContext";
import { useCart } from "../../context/CartContext";
import { ContextWrapper } from "../ContextWrapper";
import { useSessionContext } from "../../context/SessionContext";
import { VerfiyBanner } from "../VerfiyBanner";
import { lang } from "../../utilities/lang";
import { AddCircle } from "../../assets/AddCircle";
import { CartItem } from "./CartItem";
import { CartSummary } from "./CartSummary";
import { useEffect } from "react";
import { handleCartContent } from "../../helpers/helpers";

export const Checkout = () => {
    return (
        <QueryClientContext>
            <ContextWrapper preloadTax={true}>
                <Content />
            </ContextWrapper>
        </QueryClientContext>
    );
};

const Content = () => {
    const [domains, clear] = useCart((state) => [state.domains, state.clear]);
    const { session } = useSessionContext();
    const status = new URLSearchParams(window.location.search).get("status") ?? null;

    useEffect(() => {
        if (status === "success") {
            clear();
            handleCartContent();
        }
    }, [status]);
    return (
        <>
            {session && !session.verified ? <VerfiyBanner /> : null}
            <div className={`container ${session && !session.verified ? "not-verified" : ""}`}>
                <div className={"cart-content"}>
                    {status === "success" ? (
                        <>
                            <h1>{lang.get("Bestellung abgeschlossen")}</h1>
                            <a className={"button red"} href={lang.get("dashboard.url")}>
                                {lang.get("Zum Dashboard")}
                            </a>
                        </>
                    ) : (
                        <>
                            <div className={"left"}>
                                <h1>{lang.get("Warenkorb")}</h1>
                                <h2>{lang.get("Domains")}</h2>
                                <ul className={"cart-items"}>
                                    {domains.map((domain) => {
                                        return <CartItem key={domain.name} domain={domain} />;
                                    })}
                                    <li className={"add-more"}>
                                        <a href={lang.get("search.url")}>
                                            <AddCircle />
                                            {lang.get("Weitere Domains hinzufügen")}
                                        </a>
                                    </li>
                                </ul>
                            </div>
                            <CartSummary />
                        </>
                    )}
                </div>
            </div>
        </>
    );
};
